import { FiGrid, FiEdit3, FiSmartphone } from "react-icons/fi";
import styles from "../../styles/home.module.css";
import heroImage from "../../assets/hero.png";

const HeroSection = ({ onBrowse, onCustom, onAr }) => {
  return (
    <section className={styles.hero}>
      <img src={heroImage} alt="لوحة كانفس إسلامية معلقة في غرفة معيشة" className={styles.heroImage} fetchpriority="high" />

      <div className={styles.heroShade} />

      <div className={styles.heroInner}>
        <div className={styles.heroCopy}>
          <h1 className={styles.heroTitle}>لوحات كانفس إسلامية فاخرة</h1>
          <p className={styles.heroSub}>تصاميم تضيء بيتك وتذكّر قلبك</p>

          <div className={styles.heroActions}>
            <button type="button" onClick={onBrowse} className={`${styles.heroAction} ${styles.heroActionPrimary}`}>
              <FiGrid size={26} />
              <span>تصفح اللوحات</span>
            </button>

            <button type="button" onClick={onCustom} className={styles.heroAction}>
              <FiEdit3 size={26} />
              <span>صمم لوحتك</span>
            </button>

            <button type="button" onClick={onAr} className={styles.heroAction}>
              <FiSmartphone size={26} />
              <span>تجربة على حائطك (AR)</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
